<template>
  <v-container>
    <div class='text-center mt-10'>
      <p>{{ $t('reservation.attributes.fastcheckin_completed') }}</p>
      <v-row
        v-for='reservation in order.reservations'
        :key='reservation.id'
        align='center'
        justify='center'
      >
        <v-col cols='12' sm='8'>
          <ReservationCardFull
            :order="order"
            :reservation="reservation"
            :assigned="assigned"
            :redirected ="redirected"
          />
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import { orderFetchMixin } from '../../../mixins/order_fetch_mixin'
  import { orderMethodsMixin } from '../../../mixins/order_methods_mixin'
  import ReservationCardFull from '../../reservations/reservation_card_full'

  export default {
    name: 'CheckinDone',
    components: {
      ReservationCardFull,
    },
    mixins: [
      orderFetchMixin,
      orderMethodsMixin,
    ],
    mounted(){
      this.redirected =  this.$route.query.redirect
    },
    data: () => {
      return {
        assigned: true,
        redirected: null
      }
    },


    created() {
      this.fetchOrder(this.currentOrderId, this.getFreshOrder)
    },
    computed: {
      ...mapState('layout', ['loading']),
      ...mapState('order', ['order'])
    },
  }
</script>
